module.exports = __webpack_public_path__ + "assets/img/existPatient-back.850ba3e9.png";